import "./CGU.css";
import "../components/fonts.css";
import App_store from "../assets/app-store.png";
import Play_store from "../assets/playstore.png";
import Landing_header from "../components/Landing_header.js";

function CGU() {
  return (
    <>
      <Landing_header />
      <div className="Landing">
        <>
          <h1 className="title">Conditions Générales d’Utilisation</h1>
          <p className="disc">
            VEUILLEZ LIRE LES TERMES ET CONDITIONS SUIVANTS DE L’UTILISATION
            SOIGNEUSEMENT AVANT D'UTILISER NOS APPLICATIONS. TOUS LES
            UTILISATEURS DE NOS APPLICATIONS MOBILE CONVIENNENT QUE L'ACCÈS ET
            L’UTILISATION DE NOS APPLICATIONS MOBILE SONT RÉGLEMENTÉS PAR CES
            TERMES ET CONDITIONS ET À TOUTE AUTRE LOI APPLICABLE.{" "}
          </p>
          <p className="title2">Utilisation de l'application</p>
          <p className="disc">
            L'utilisateur s'engage à utiliser l'application Happer de manière
            licite et conformément aux présentes conditions générales
            d'utilisation. L'utilisateur est responsable de la sécurité de son
            compte et de ses identifiants de connexion. Il est interdit
            d'utiliser l'application à des fins frauduleuses ou pour nuire à
            autrui.
          </p>
          <p className="title2">Propriété intellectuelle</p>
          <p className="disc">
            1.1. La structure générale du site et des applications Happer, ainsi
            que les textes, graphiques, images, sons et vidéos la composant,
            sont la propriété de l’éditeur ou de ses partenaires. Toute
            représentation et/ou reproduction et/ou exploitation partielle ou
            totale des contenus et services proposés par Happer, par quelque
            procédé que ce soit, sans l’autorisation préalable et par écrit est
            strictement interdite et serait susceptible de constituer une
            contrefaçon au sens des articles L335-2 et suivants du Code de la
            propriété intellectuelle
          </p>
          <p className="disc">
            1.2. Aucune reproduction, même partielle prévue à l’article L.122-5
            du Code de la propriété intellectuelle, ne peut être faite de ce
            site ni des applications sans l’autorisation du directeur de
            publication.
          </p>
          <p className="disc">
            1.3. Tous les éléments de ce site et des applications Happer, y
            compris les documents téléchargeables, sont libres de droit. A
            l’exception de l’iconographie, la reproduction des pages de ce site
            est autorisée à la condition d’y mentionner la source. Elles ne
            peuvent être utilisées à des fins commerciales et publicitaires.
          </p>
          <p className="disc">
            1.4 Tous les éléments de l'application Happer, tels que les photos,
            les descriptions et les logos, sont protégés par les lois relatives
            à la propriété intellectuelle. Toute reproduction ou utilisation non
            autorisée est strictement interdite.
          </p>
          <p className="title2">
            Modification des conditions générales d’utilisation
          </p>
          <p className="disc">
            2.1 L'entreprise Woman and Luxury se réserve de modifier les
            conditions générales d’utilisation du site et des applications
            Happer à tout moment et sans préavis afin de les adapter aux
            potentielles évolutions du site et des applications.
          </p>
          <p className="disc">
            2.2 Les modifications seront publiées sur l'application Happer et
            seront applicables aux utilisateurs à compter de leur publication.
          </p>
          <p className="disc">
            2.3 Les utilisateurs seront prévenus par une alerte de mise à jour
            des conditions générales d’utilisation.
          </p>
          <p className="title2">Condition d’inscription</p>
          <p className="disc">
            3.1. Certaines fonctionnalités du site et des applications requiert
            la création d’un compte client. Lors de l’inscription vous êtes
            invité à remplir un formulaire afin de nous procurer quelques
            informations nécessaires à votre identification. De ce fait sont
            obligatoires, la création d’un nom, prénom, d’un mot de passe et le
            renseignement d’une adresse mail afin de valider votre compte.
          </p>
          <p className="disc">
            3.2. L’enregistrement sur le site ou les applications est également
            sous réserve des termes et conditions suivantes :
          </p>
          <p className="disc">
            3.2.1. L’inscription à Happer est destinée uniquement à un usage
            personnel. L’adhésion n’est pas autorisée pour des fins
            commerciales, y compris des détaillants. Les produits gagnés ne sont
            pas destinés à la revente.
          </p>
          <p className="disc">
            3.2.4. Happer se réserve le droit de limiter l’offre de certains
            utilisateurs, s'ils sont suspectés d'acheter les produits pour des
            fins commerciales.
          </p>
          <p className="disc">
            3.2.5. Les utilisateurs sont limités à un compte par personne.
          </p>
          <p className="disc">
            3.2.6. Happer se réserve le droit de limiter le nombre de comptes
            par utilisateur et/ ou IP address, adresse physique, adresse
            électronique ;
          </p>
          <p className="disc">
            3.2.7. L’adhésion n’est pas transmissible. En particulier, vous ne
            devez pas permettre à d’autres d’employer votre adhésion et vous ne
            devez pas virer ou vendre votre adhésion sur une autre personne.
          </p>
          <p className="disc">
            3.2.8. Le mot de passe du compte que vous fournissez devra être
            unique et personnel.
          </p>
          <p className="title2">Accès au site et aux applications mobile</p>
          <p className="disc">
            4.1.L’éditeur s’efforce de permettre l’accès au site et aux
            applications 24 heures sur 24, 7 jours sur 7, sauf en cas de force
            majeure ou d’un événement hors du contrôle de l’éditeur, et sous
            réserve des éventuelles pannes et interventions de maintenance
            nécessaires au bon fonctionnement du site, des applications et des
            services.
          </p>
          <p className="disc">
            Par conséquent, l’éditeur ne peut garantir une disponibilité du
            site, des applications et/ou des services, une fiabilité des
            transmissions et des performances en termes de temps de réponse ou
            de qualité. Il n’est prévu aucune assistance technique vis-à-vis de
            l’utilisateur que ce soit par des moyens électroniques ou
            téléphoniques.
          </p>
          <p className="disc">
            La responsabilité de l’éditeur ne saurait être engagée en cas
            d’impossibilité d’accès à ce site, des applications et/ou
            d’utilisation des services.
          </p>
          <p className="disc">
            4.2. L’éditeur peut être amené à interrompre le site et/ou les
            applications ou une partie des services, à tout moment sans préavis,
            le tout sans droit à indemnités. L’utilisateur reconnaît et accepte
            que l’éditeur ne soit pas responsable des interruptions, et des
            conséquences qui peuvent en découler pour l’utilisateur ou tout
            tiers.
          </p>
          <p className="title2">Jeu et produits à happer</p>
          <p className="disc">
            5.1. Aucun honoraire n’est demandé pour les produits à happer, ils
            sont placés gratuitement sur le site et les applications et peuvent
            être remportés par les utilisateurs.
          </p>
          <p className="disc">
            5.2. Chaque nouvelle offre remet à zéro le compte à rebours restant
            (habituellement de 30 secondes).
          </p>
          <p className="disc">
            5.3. Quand une offre est placée par un utilisateur, un crédit est
            déduit du solde total du membre et l’utilisateur a “la main” sur le
            produit. Le produit est remporté quand plus aucunes offres n’est
            reçues par les serveurs de Happer.
          </p>
          <p className="disc">
            5.4. Nous ne sommes pas responsables des ruptures ou des erreurs qui
            résultent de votre connexion internet ou d’autres causes
            indépendantes de notre volonté raisonnable.
          </p>
          <p className="disc">
            5.5 Le système d'enchères permet aux clients de participer à des
            enchères pour obtenir des produits de mode à des prix avantageux.
            Les crédits nécessaires pour participer aux enchères peuvent être
            obtenus en partageant son style vestimentaire ou en parrainant des
            utilisateurs. Les règles et modalités du système d'enchères sont
            détaillées sur l'application.
          </p>
          <p className="title2">Rétractation d’offre</p>
          <p className="disc">
            6. Si vous remportez un gain au jeu Happer et ne souhaitez pas
            procéder à l’acquisition de la marchandise, nous vous remboursons
            les crédits dépensés sur le produit, à la demande de l’utilisateur.
          </p>
          <p className="title2">Livraison</p>
          <p className="disc">
            8.1 La livraison est dépendante de nos partenaires et envoyée à
            votre domicile.
          </p>
          <p className="disc">
            8.2 La livraison sera assurée par nos partenaires dans les délais
            accordés par eux-mêmes. Cependant les problèmes d’approvisionnement
            ou une demande inattendue peuvent de temps en temps avoir comme
            conséquence des retards.
          </p>
          <p className="disc">
            Si jamais il y a un retard, nous vous contacterons au plus tôt pour
            vous informer de la raison du retard. Nous ne sommes responsables
            d’aucun retard qui peut être causé par la livraison des produits.
          </p>
          <p className="title2">Retours et échanges</p>
          <p className="disc">
            9.1 Si vous souhaitez renvoyer des produits que vous achetez ou
            gagnez sur nos applications, nous vous invitons à prendre contact
            avec happer depuis nos applications.
          </p>
          <p className="disc">
            9.2 Les retours seront acceptés selon les modalités de nos
            partenaires.
          </p>
          <p className="disc">
            9.3 Le ou les produits devront être rendus dans leurs états
            d’origine, c'est-à-dire inutilisés avec toutes les étiquettes de
            vêtement jointes.
          </p>
          <p className="disc">
            9.4 Les articles endommagés ou souillés qui sont renvoyés à nos
            partenaires ne seront pas acceptés et seront renvoyés au client.
          </p>
          <p className="title2">Produits à remporter</p>
          <p className="disc">
            10.1 Nous attestons que les marchandises seront conformes aux
            descriptions données sur les applications mobiles.
          </p>
          <p className="disc">
            10.2 Tous les produits sont neufs et authentiques.
          </p>
          <p className="title2">
            Conduite inadéquate d’utilisateur sur le site et les applications
          </p>
          <p className="disc">
            11.1 Sont strictement interdits le harcèlement de n’importe quelle
            façon ou la forme au sein de la communauté Happer, incluant par
            l’intermédiaire de l’email, de la causerie, ou au moyen de la langue
            obscène ou abusive.
          </p>
          <p className="disc">
            11.3 Vous ne pouvez publier du contenu diffamatoire, obscène,
            envahissant les droits d’intimité ou de publicité, abusif, illégal,
            ou autrement de répréhensible qui peuvent constituer ou encourager
            un crime, violer les droits de n’importe quelle partie ou qui
            peuvent autrement provoquer la responsabilité ou violer n’importe
            quelle loi.
          </p>
          <p className="disc">
            11.4 Happer se réserve le droit de clôturer le compte des
            utilisateurs n'ayant pas un comportement adéquat. Happer se réserve
            le droit de résilier le compte d'un utilisateur en cas de
            non-respect des présentes conditions générales d'utilisation ou en
            cas de comportement frauduleux.
          </p>
          <p className="title2">Aucune utilisation commerciale</p>{" "}
          <p className="disc">
            12. Ces applications mobiles ne peuvent être utilisées
            commercialement. Vous ne pouvez ni copier ni distribuer ou
            commercialement exploiter le matériel sans accord écrit des
            dirigeants des applications mobiles.
          </p>
          <p className="title2">Votre activité</p>{" "}
          <p className="disc">
            13.1 Vous convenez que vous serez personnellement responsable de
            l'usage que vous ferez de ces applications et de votre communication
            sur nos applications . Si nous déterminons que vous êtes ou avez été
            engagés dans des activités interdites, n’étaient pas respectueux
            d’autres utilisateurs, ou ont autrement violé les termes et
            conditions, nous pouvons vous refuser l’accès à nos applications
            mobiles sur une base provisoire ou permanente.
          </p>{" "}
          <p className="disc">
            13.2 N’importe quel abus ou violation d’un compte utilisateur aura
            comme conséquence la disqualification de l’utilisateur et peut
            également avoir comme conséquence les poursuites pénales
          </p>{" "}
          <p className="disc">
            13.3 Nous ne tolérons pas de quelque façon l’activité inadéquate et
            frauduleuse, et chercherons des sanctions criminelles et
            contractuelles contre toute personne impliquée dedans ou suspectée
            de la participation dans la fraude, la malhonnêteté ou les actes
            criminels, ou la connivence, ou la connivence suspectée avec
            d’autres personnes impliquées dans la fraude, la malhonnêteté ou les
            actes criminels.
          </p>{" "}
          <p className="disc">
            13.4 L'application Happer permet aux utilisateurs de générer du
            contenu photos. L'utilisateur est responsable du contenu qu'il
            génère et s'engage à respecter les lois en vigueur, ainsi que les
            droits de propriété intellectuelle des tiers.
          </p>{" "}
          <p className="disc">
            13.5 Happer collecte des données personnelles des utilisateurs pour
            assurer le bon fonctionnement de l'application. Les données
            collectées sont traitées conformément à la politique de
            confidentialité disponible sur l'application.
          </p>
          <p className="title2">Arrêt des applications Happer</p>{" "}
          <p className="disc">
            14. Happer se réserve le droit de fermeture ou de suspension des
            applications mobiles pour des raisons quelconque.
          </p>
          <p className="title2">Litige</p>{" "}
          <p className="disc">
            15. Tant les présentes applications mobiles que les modalités et
            conditions de son utilisation sont régies par le droit français,
            quel que soit le lieu d’utilisation. En cas de contestation
            éventuelle, et après l’échec de toute tentative de recherche d’une
            solution amiable, les tribunaux français seront seuls compétents
            pour résoudre le litige.
          </p>
          <p className="disc"></p>
        </>
      </div>
    </>
  );
}

export default CGU;
